module.exports = __webpack_public_path__ + "static/media/icefields-1.9c4b8891.jpg";